import React from 'react';
import { Text } from '@chakra-ui/react';
import { CreditsList } from 'app/components/Song/Credits/CreditsList';
import { ContentContainer } from 'app/components/Core';
import { ContentContainerType } from 'types/enums';

export const Credits: React.FC = () => (
  <ContentContainer
    type={ContentContainerType.LIST}
    isViewContent
    pt={4}
    pb={0}
    height="full"
  >
    <Text color="textSubdued">
      The list of Songs you have been credited on.
    </Text>
    <CreditsList />
  </ContentContainer>
);
